import React from 'react';

export default function De() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18">
      <path fill="#FFDA44" d="M0.56 12.13a9.003 9.003 0 0 0 16.88 0L9 11.348z" />
      <path fill="#000" d="M9 0A9 9 0 0 0 0.56 5.87L9 6.652l8.44 -0.782A9 9 0 0 0 9 0" />
      <path
        fill="#D80027"
        d="M0.56 5.87A9 9 0 0 0 0 9a9 9 0 0 0 0.56 3.13h16.88A9 9 0 0 0 18 9a9 9 0 0 0 -0.56 -3.13z"
      />
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
